import axios from 'axios';
import copys from './copys';
import { Response } from '../types/common';

export const apiErrorHandler = async (error: any,): Promise<Response<any>> => {
    if (axios.isAxiosError(error)) {
        console.log('AxiosError', error);
        const isClientSideNetworkError = await checkIfIsClientNetworkError(error);
        if (isClientSideNetworkError) {
            return { successful: false, errors: [{ code: 'client_network_error' }], data: {}, message: 'Error de red' }
        }
        const errorResponse = error.response?.data;
        if (errorResponse) {
            return { ...errorResponse, data: { code: error.status } };
        }
    }
    console.error(error)
    return { successful: false, message: copys.toastErrorMessageDefault, errors: [error], data: {} };
}

const checkIfIsClientNetworkError = async (error: any) => {
    const pingUrl =
        process.env.REACT_APP_PING_URL ||
        'https://clients3.google.com/generate_204';
    let isClientNetworkError = false;
    if (!error.response || error.message === 'Network Error') {
        if (!navigator.onLine) {
            isClientNetworkError = true;
        } else {
            try {
                const controller = new AbortController();
                const timeout = setTimeout(() => controller.abort(), 2000);

                const response = await fetch(pingUrl, {
                    method: 'HEAD',
                    signal: controller.signal,
                });

                if (!response.ok) {
                    isClientNetworkError = true;
                }
                clearTimeout(timeout);
            } catch {
                isClientNetworkError = true;
            }
        }
    }
    return isClientNetworkError;
};
